export default __webpack_public_path__ + "static/media/wht-cat-4.48b4ee83.svg";